export function getLifecycleDialogConfig(action, entityLabel = 'persoon') {
  switch (action) {
    case 'deactivate':
      return {
        title: `${capitalize(entityLabel)} deactiveren?`,
        html: `
          <div style="text-align:left;">
            <p>Deze ${entityLabel} wordt <strong>inactief</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>Inloggen is niet meer mogelijk</li>
              <li>De gegevens blijven behouden</li>
              <li>Later kan deze ${entityLabel} weer geheractiveerd worden</li>
            </ul>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'Ja, deactiveer',
        successTitle: 'Gedeactiveerd',
        successText: `${capitalize(entityLabel)} is gedeactiveerd.`
      };

    case 'reactivate':
      return {
        title: `${capitalize(entityLabel)} heractiveren?`,
        html: `
          <div style="text-align:left;">
            <p>Deze ${entityLabel} wordt weer <strong>actief</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>De ${entityLabel} kan weer normaal gebruikt worden</li>
            </ul>
          </div>
        `,
        icon: 'question',
        confirmButtonText: 'Ja, heractiveer',
        successTitle: 'Geheractiveerd',
        successText: `${capitalize(entityLabel)} is geheractiveerd.`
      };

    case 'unenroll':
      return {
        title: `${capitalize(entityLabel)} uitschrijven?`,
        html: `
          <div style="text-align:left;">
            <p>Deze ${entityLabel} wordt <strong>uitgeschreven</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>De leerling is niet meer actief ingeschreven</li>
              <li>De gegevens blijven behouden</li>
              <li>Later kan de leerling opnieuw worden ingeschreven</li>
            </ul>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'Ja, uitschrijven',
        successTitle: 'Uitgeschreven',
        successText: `${capitalize(entityLabel)} is uitgeschreven.`
      };

    case 'reenroll':
      return {
        title: `${capitalize(entityLabel)} opnieuw inschrijven?`,
        html: `
          <div style="text-align:left;">
            <p>Deze ${entityLabel} wordt weer <strong>actief ingeschreven</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>De leerling wordt opnieuw actief binnen het systeem</li>
            </ul>
          </div>
        `,
        icon: 'question',
        confirmButtonText: 'Ja, herinschrijven',
        successTitle: 'Heringeschreven',
        successText: `${capitalize(entityLabel)} is opnieuw ingeschreven.`
      };

    case 'archive':
      return {
        title: `${capitalize(entityLabel)} archiveren?`,
        html: `
          <div style="text-align:left;">
            <p>Deze ${entityLabel} wordt <strong>gearchiveerd</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>Verdwijnt uit standaard overzichten</li>
              <li>Gegevens blijven bewaard voor administratie</li>
              <li>Daarna kan deze ${entityLabel} eventueel geanonimiseerd worden</li>
            </ul>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'Ja, archiveer',
        successTitle: 'Gearchiveerd',
        successText: `${capitalize(entityLabel)} is gearchiveerd.`
      };

    case 'anonymize':
      return {
        title: `${capitalize(entityLabel)} anonimiseren?`,
        html: `
          <div style="text-align:left;">
            <p>De persoonsgegevens van deze ${entityLabel} worden <strong>onomkeerbaar geanonimiseerd</strong>.</p>
            <ul style="padding-left:18px; margin-bottom:0;">
              <li>Naam, e-mail en telefoon worden verwijderd of onherkenbaar gemaakt</li>
              <li>Deze actie kan niet ongedaan worden gemaakt</li>
              <li>Alleen noodzakelijke administratieve referenties blijven behouden</li>
            </ul>
          </div>
        `,
        icon: 'error',
        confirmButtonText: 'Ja, anonimiseer',
        successTitle: 'Geanonimiseerd',
        successText: `${capitalize(entityLabel)} is geanonimiseerd.`
      };

    default:
      return {
        title: 'Weet je het zeker?',
        html: '<p>Wil je doorgaan met deze actie?</p>',
        icon: 'question',
        confirmButtonText: 'OK',
        successTitle: 'Gelukt',
        successText: 'De actie is uitgevoerd.'
      };
  }
}

function capitalize(value = '') {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}